import useTracker from '@hooks/useTracker';
import {
  CLICK_FORGOT_PIN,
  CLICK_SUBMIT_PIN,
  VISIT_PIN_PAGE,
  PIN_INPUT_VIEW,
  PIN_INPUT_CLICK,
  PIN_VERIFYING,
  PIN_APP_SOURCE,
  PIN_METHOD,
  PIN_STATUS,
} from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventVisitPinPage = () => {
    trackEvent(VISIT_PIN_PAGE);
  };

  const eventClickForgotPin = () => {
    trackEvent(CLICK_FORGOT_PIN);
  };

  const eventSubmitPin = (props) => {
    trackEvent(CLICK_SUBMIT_PIN, props);
  };

  const eventPinInputView = (entryPoint) => {
    trackEvent(PIN_INPUT_VIEW, {
      app_source: PIN_APP_SOURCE,
      entry_point: entryPoint,
    });
  };

  const eventPinInputClick = (entryPoint, click) => {
    trackEvent(PIN_INPUT_CLICK, {
      app_source: PIN_APP_SOURCE,
      entry_point: entryPoint,
      click,
    });
  };

  const eventPinVerifying = (entryPoint, status, failReason) => {
    trackEvent(PIN_VERIFYING, {
      app_source: PIN_APP_SOURCE,
      entry_point: entryPoint,
      method: PIN_METHOD.PIN,
      status,
      ...(status === PIN_STATUS.FAIL ? { fail_reason: failReason || '' } : {}),
    });
  };

  return {
    eventVisitPinPage,
    eventClickForgotPin,
    eventSubmitPin,
    eventPinInputView,
    eventPinInputClick,
    eventPinVerifying,
  };
};

export default useEventTracker;
